<template>
  <v-dialog v-model="dialog" width="90%">
    <v-card elevation="3">
      <div class="pp-sidenav">
        <v-card-title class="white--text">
          Publish a Category
        </v-card-title>

        <v-card-subtitle class="white--text">
          Add details below
        </v-card-subtitle>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs
          dark
          width="250"
          color="primary"
          vertical
      >
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-plus
          </v-icon>
          Category Details
        </v-tab>

        <v-tab-item>
          <v-card flat>
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Add Category Details
                  </v-card-title>

                  <div class="py-5 pa-3">
                    <v-card-text>
                      <v-row>
                        <v-text-field
                            v-model="add.name"
                            aria-required="true"
                            color="primary"
                            label="Category Title"
                            placeholder="Add a Category Name"
                            prepend-icon="mdi-file-edit-outline"
                            flat
                            solo
                            clearable
                        ></v-text-field>
                      </v-row>
                      <v-row v-if="categoryApiError && categoryApiError.fields && categoryApiError.fields.name"
                          class="err-text">
                        <p class="error--text">
                          Category title should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <v-row>
                        <v-textarea
                            v-model="add.description"
                            auto-grow hint="The description of the category will be publicly visible"
                            persistent-hint
                            label="Category Description"
                            class="mb-7"
                            aria-required="true"
                            color="primary"
                            placeholder="Add a Category Description"
                            prepend-icon="mdi-format-line-style"
                            flat
                            solo
                            clearable
                        >
                        </v-textarea>
                      </v-row>

                      <v-row v-if="categoryApiError && categoryApiError.fields && categoryApiError.fields.description"
                          class="err-text">
                        <p class="error--text">
                          Category description should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <ImagePicker v-model="add.image"/>

                      <TagsInput
                          v-model="add.tags"
                          :validationError="categoryApiError"
                      />

                      <v-row v-if="categoryApiError">
                        <v-alert
                            text
                            color="red"
                            icon="mdi-alert-circle-outline"
                        >
                          There was an error in submission. Please check all fields and try again.
                        </v-alert>
                      </v-row>
                    </v-card-text>
                  </div>
                </v-card>
              </template>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <div class="pp-sidenav">
        <div class="btm">
          <Loading v-if="categoryItemLoading"/>
          <ConfirmCancelButtons
              :item="add"
              confirm-text="Create Category"
              :confirm-action="addItemConfirm"
              :cancel-action="closeDialog"
              :confirm-disabled="categoryItemLoading"/>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import ImagePicker from "@/components/common/ImagePicker";
import Loading from "@/components/common/Loading";
import TagsInput from "@/components/common/TagsInput";

export default {
  name: "CategoryAdd",
  components: {
    TagsInput, Loading, ImagePicker, ConfirmCancelButtons,
  },
  data() {
    return {
      add: {
        name: '',
        description: '',
        image: undefined,
        tags: [],
      },
    };
  },
  computed: {
    ...mapGetters(['categoryApiError', 'openDialog', 'categoryItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'categoryAdd';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['addCategory', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.reset();
    },
    async addItemConfirm() {
      const added = await this.addCategory(this.add);

      if (added) {
        this.reset();
      }
    },
    reset() {
      this.closeOpenDialog();
      this.add = {
        name: '',
        description: '',
        image: undefined,
        tags: [],
      };
    },
  },
};
</script>
